import login from "@/api/login";
import statistics from "@/api/statistics";
import achievement from "@/api/achievement";
import demand from "@/api/demand";
import patent from "@/api/patent";
import typicalCase from "@/api/typical_case";
import recommend from "@/api/recommend";
import policy from "@/api/policy";
import machining from "@/api/machining";
import privilege from "@/api/privilege";
import service from "@/api/service";
import solution from "@/api/solution";
import activity from "@/api/activity";
import project from "@/api/project";
import expert from "@/api/expert";
import competition from "@/api/competition";
import user from "@/api/user";
import system from "@/api/system";
const request = {
  login,
  statistics,
  achievement,
  demand,
  patent,
  typicalCase,
  recommend,
  activity,
  policy,
  machining,
  privilege,
  service,
  solution,
  project,
  expert,
  competition,
  user,
  system
};
const api = (module, method, params) => {
  return request[module][method](params);
};
export default api;
